import { salesDespatchPackSummaryReport } from './sales-despatch-pack-summary-report';
import { SalesDespatchItemReport } from './sales-despatch-item-report';
import { SalesDespatchProductReport } from './sales-despatch-product-report';
import { SellingCompanyReport } from '../../../../tms-shared';
import { SalesDespatchProductSummaryReport } from './sales-despatch-product-summary-report';
import { SalesDespatchCustomsSummaryReport } from './sales-despatch-customs-summary-report';
import { SalesDespatchOrderReport } from './sales-despatch-order-report';

export interface SalesDespatchNoteReport {
  id: string;
  despatchNoteNo: number;
  despatchDate: Date;
  customerKey: string;
  customerName: string;
  customerDespatchNoteEmail: string;
  customerAddressMultiLine: string;
  customerAddressSingleLine: string;
  deliveryAddressMultiLine: string;
  shipperSupplier: string;
  shippingMarks: string;
  shippingNotes: string;
  deliveryTerm: string;
  deliveryTermNotes: string;
  modeOfTransport: string;
  trackingNo: string;
  salesOrderNo: string;
  customerOrderRef: string;
  customerOrderNo: string;
  documentNotes: string;
  notes: string;
  grossQuantity: number;
  nettQuantity: number;
  grossQuantityString: string;
  nettQuantityString: string;
  noOfItems: number;
  goodsValue: number;
  orderedBy: string;
  deliveryAddressee: string;
  printDeliveryAddress: boolean;
  currencySymbol: string;
  unitOfMeasure: string;

  sellingCompany: SellingCompanyReport;
  salesDespatchItems: SalesDespatchItemReport[];
  salesDespatchProducts: SalesDespatchProductReport[];
  salesDespatchOrders: SalesDespatchOrderReport[];
  salesPackSummary: salesDespatchPackSummaryReport[];
  salesProductSummary: SalesDespatchProductSummaryReport[];
  salesCustomsSummary: SalesDespatchCustomsSummaryReport[];
}
